var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector44325725(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 47,
    viewBox: "0 0 97 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 44325725",
    opacity: 0.1,
    d: "M86.1057 46.6098H65.2731H11.3957C8.76167 45.7066 0.174614 42.1419 0.620221 33.7401C1.33872 20.193 17.8618 22.9024 16.4243 21.5477C16.9032 20.193 16.5562 14.4735 21.4529 12.7421C26.3497 11.0107 31.079 12.7421 33.665 14.7742C34.2467 15.2313 33.665 1.90444 45.1588 0.549731C60.2445 -1.22832 60.8731 13.4195 61.6813 12.7421C63.8364 10.9358 67.4282 6.95855 75.3302 8.67798C83.9506 10.5537 84.9084 18.6125 83.9506 22.225C82.5138 22.9024 94.0077 21.5477 96.1628 32.3854C97.7791 40.5136 90.4159 44.5777 86.1057 46.6098Z",
    fill: "#00004B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector44325725);
export default __webpack_public_path__ + "static/media/Vector 44325725.31dcff15e935c01eb56a54a74851d177.svg";
export { ForwardRef as ReactComponent };